module.exports = __webpack_public_path__ + "assets/img/img212.f259d8f9.png";